module.exports = __webpack_public_path__ + "img/logo.109bc8b0.png";